<template>
  <div id="detailsRow" class="row">
    <div class="col-4 label-text">{{ label }}</div>
    <div class="col-8">{{ field }}</div>
  </div>
</template>

<script>
export default {
  props: [
    'label',
    'field',
  ],
};
</script>

<style scoped lang="scss">
@import '../../sass/base';

#detailsRow {
  @extend .py-1;

  &:first-child {
    @extend .pt-0;
  }

  &:last-child {
    @extend .pb-0;
  }
};
</style>
